import { atom, selector } from 'recoil';
import { PlaceDto } from '@/model/place.dto';

export const placeListRecoil = atom<PlaceDto[] | null>({
  key: 'placeListRecoil',
  default: null,
});

export const placeListLengthRecoil = atom<number | undefined>({
  key: 'placeListLengthRecoil',
  default: 0,
});

export const placeModifyNumRecoil = atom<number | null>({
  key: 'placeModifyNumRecoil',
  default: null,
});

export const placeModifyRecoil = selector<PlaceDto | null>({
  key: 'placeModifyRecoil',
  get: ({ get }) => {
    const list = get(placeListRecoil);
    const modifyNum = get(placeModifyNumRecoil);
    if (list && modifyNum !== null) {
      return list.find((item) => item.id === modifyNum) || null;
    } else {
      return null;
    }
  },
});
